<script> 
    import {
        fade
    } from 'svelte/transition';
    export let text;    
    export let href;    
    export let notif =false; 
    export let lg = "w-1/5";
    export let md = "w-1/6";
    export let xs = "w-1/4";
    export let css = "bg-white";
</script>


<a in:fade={{delay:100, duration: 1000}} class=" transform transition-all duration-300 scale-100 hover:scale-95 group mx-auto my-1 mb-0 p-0 lg:{lg} md:{md} {xs}"
    href="{href}">
    <div 
        class="mx-1 h-full items-center text-center p-2 rounded-lg hover:shadow-lg hover:font-bold hover:bg-gray-200 transition delay-50 duration-300 ease-in-out {css}">
        <div class="w-14 h-14 lg:bg-transparent md:bg-transparent bg-white object-cover object-center clear-both rounded-lg mx-auto relative">
            {#if notif}
            {#if notif !="0"}
            <span class="absolute top-0 right-0 rounded-full bg-red-600 text-white px-2 text-xs">{notif}</span>
            {/if}
            {/if}
<slot></slot>
        </div>
        <div class="relative overflow-hidden truncate"> 
            <small class="grup-hover:font-bold">{text}</small>
        </div>
    </div>
</a>